// extracted by mini-css-extract-plugin
export default {"loader":"HOCRequestLoader_loader__4b7fh"};